import './mainPage.css';
import Footer from './Components/Footer';
import Header from './Components/Header';
import SearchBar from './Components/searchBar';

export default function MainPage(){
  return(
    <div id='container'>
      <Header/>
      <SearchBar/>
      <div className='padding10'>
        <p className='center-text'>Find out more information about GitHub users and what they have publish.</p>
        <p className='center-text'>If you want to try an example, look up yoselineguerrero or click on the random user button.</p>
      </div>
      <Footer/>
    </div>
  );
}